import { useRef, useState } from 'react'
import './CustomVideoPlayer.css'
import { IoMdPlay, IoMdPause, IoMdVolumeHigh, IoMdVolumeOff } from "react-icons/io";
import { MdFullscreen, MdFullscreenExit  } from "react-icons/md";
import useCustomVideoPlayer from '../../../../hooks/useCustomVideoPlayer';

const CustomVideoPlayer = ({
    uniqueName,
    caseType = 'normal' // normal || qr 
}) => {
  const {
    videoRef,
    playerContainerRef,
    isPlaying,
    togglePlay,
    handleTimeUpdate,
    handleProgressChange,
    handleVolumeChange,
    toggleMute,
    handleVideoEnded,
    toggleFullScreen,
    isMuted,
    isFullScreen,
    progress,
    currentTime,
    duration,
    volume
  } = useCustomVideoPlayer();

  let video

  switch (caseType) {
    case 'normal':
      video = <video 
            data-video={ `video-${uniqueName}-modal-preview` } 
            id='video-record-rtc-preview'
            className='d-none' 
            playsInline
            ref={ videoRef }
            onClick={togglePlay} 
            onTimeUpdate={handleTimeUpdate}
            onEnded={handleVideoEnded}
          /> 
      break;
    case 'qr':
      video = <video className='d-none' data-video='video-preview'
            id='qr-video-preview'
            style={{ maxHeight: '42vh', width: '100%'}}
            playsInline
            ref={ videoRef }
            onClick={togglePlay} 
            onTimeUpdate={handleTimeUpdate}
            onEnded={handleVideoEnded}
          >
        <source id='video-preview-src-1' type='video/mp4' />
        <source id='video-preview-src-2' type='video/webm' />
        <source id='video-preview-src-3' type='video/ogg' />

      </video>
      break;
    case 'incoming-video-modal':
      video = <video data-video='video-preview' id='preview-qr'
        style={{
          width: '100%',
        }}
        ref={ videoRef }
        onClick={togglePlay} 
        onTimeUpdate={handleTimeUpdate}
        onEnded={handleVideoEnded}
      >
        <source src='' id='preview-qr-src-1' type='video/mp4' />
        <source src='' id='preview-qr-src-2' type='video/webm' />
        <source src='' id='preview-qr-src-3' type='video/ogg' />

      </video> 
      break;
    default:
      break;
  }

  return (
    <div className='video-container' ref={ playerContainerRef }>
      {
        video
      }

      {/* Custom Controls */}
      <div className='controls-overlay'>

        <div className="controls-actions mb-1">

          <div className="left-controls">
            <button onClick={togglePlay} className="control-btn">
              {isPlaying ? 
              <div className=' p-1.5 px-2 flex items-center justify-center rounded-full group-hover transition-colors duration-400'>
                <IoMdPause size={20} /> 
              </div> :
              <div className=' p-1.5 px-2 flex items-center justify-center rounded-full group-hover transition-colors duration-400'>
                <IoMdPlay size={20} />
              </div>}
            </button>

            <span className="time-display text-xs! ">
              {currentTime} { duration ? `/ ${duration}` : '' }
            </span>
          </div>


          <div className="right-controls">
            <div className="right-controls-inner-wrapper">
              {/* Volume */}
              <div className="volume-container group-hover:bg-gray-700 transition-colors duration-400">
                <input 
                  type="range" 
                  min="0" 
                  max="1" 
                  step="0.05" 
                  value={isMuted ? 0 : volume} 
                  onChange={handleVolumeChange}
                  className="volume-slider" 
                />
                <button onClick={toggleMute} className="control-btn">
                  {isMuted || volume === 0 ? <IoMdVolumeOff size={20} /> : <IoMdVolumeHigh size={20} />}
                </button>
              </div>
              {/* Full Screen */}
            </div>
            <button onClick={toggleFullScreen} className="control-btn">
              {isFullScreen ? <MdFullscreenExit size={20} /> : <MdFullscreen size={20} />}
            </button>
          </div>
        </div>

        {/* Progress bar */}
        <input
          type="range"
          min="0"
          max="100"
          step='0.001'
          value={progress}
          onChange={handleProgressChange}
          className="progress-bar"
        />

      </div>

    </div>
  )
}

export default CustomVideoPlayer